export const CHANGE_SETTINGS = "meta-tags/CHANGE_SETTINGS";

export const GET_META_TAGS = "meta-tags/GET_META_TAGS";
export const GET_META_TAGS_SUCCESS = "meta-tags/GET_META_TAGS_SUCCESS";
export const GET_META_TAGS_FAILURE = "meta-tags/GET_META_TAGS_FAILURE";

export const EDIT_META_TAG = "meta-tags/EDIT_META_TAG";
export const EDIT_META_TAG_SUCCESS = "meta-tags/EDIT_META_TAG_SUCCESS";
export const EDIT_META_TAG_FAILURE = "meta-tags/EDIT_META_TAG_FAILURE";
